import React from "react";
import { IconAccessible, IconExternalLink, IconPhone, IconForms, IconMail } from "@tabler/icons-react";
import { SpotlightActionData } from "@mantine/spotlight";
import { navigate } from "vike/client/router";

// ⚡⚡ Quick Note: Please adapt to your business needs!

async function onSubmit(route: string) {
  const navigationPromise = navigate(route);
  await navigationPromise;
}

export const accessibility: SpotlightActionData[] = [
  {
    id: "accessibility-overview",
    label: "Our Accessibility Promise",
    description:
      "We’re serious (but fun!) about making the web a better place for everyone. Our app uses Mantine, a super accessible design system, and follows OPQUAST quality rules for rock-solid web best practices.",
    onClick: () => window.open("https://www.opquast.com/en/about-us/", "_blank", "noreferrer,noopener"),
    rightSection: <IconAccessible aria-label="Go to Accessibility Overview" size={24} stroke={1.5} />,
  },
  {
    id: "display-customization",
    label: "Customize Your Display 🎨",
    description:
      "Need bigger text? Different fonts? High contrast? Our Display & Accessibility Drawer lets you tweak everything: colors, radius, focus rings, luminance threshold, and more. Built 100% with [Learn more about Mantine], because accessibility should always be stylish.",
    onClick: () => window.open("https://mantine.dev/", "_blank", "noreferrer,noopener"),
    rightSection: <IconAccessible aria-label="Go to Display Customization" size={24} stroke={1.5} />,
  },
  {
    id: "keyboard-shortcuts",
    label: "Keyboard Shortcuts 🚀",
    description:
      "For all the speed lovers out there: jump straight to menus, themes, or content with a tap! Our shortcuts make navigation super easy for everyone, especially keyboard users. More love, less clicks ❤️.",
    onClick: () => onSubmit("/accessibility"),
    leftSection: <IconAccessible aria-label="Go to Keyboard Shortcuts" size={24} stroke={1.5} />,
  },
  {
    id: "improvement-feedback",
    label: "Give Us Feedback 💬",
    description:
      "Found a bug? Accessibility problem? We care a lot. Drop us an email and let's make it better together. Every suggestion makes the web a bit brighter ✨.",
    onClick: () => window.open("mailto:contact@myapplication.mydomain", "_blank", "noreferrer,noopener"),
    rightSection: <IconMail aria-label="Open your default email app" size={24} stroke={1.5} />,
  },
  {
    id: "ombudsman-support",
    label: "Official Help Needed?",
    description:
      "If something’s wrong and we don't fix it fast enough, you can contact the Défenseur des Droits. They're like accessibility superheroes in France 🦸‍♂️.",
    onClick: () => window.open("https://formulaire.defenseurdesdroits.fr/", "_blank", "noreferrer,noopener"),
    rightSection: <IconForms aria-label="Open Ombudsman contact form" size={24} stroke={1.5} />,
  },
  {
    id: "regional-ombudsman",
    label: "Find Your Local Ombudsman",
    description:
      "Not in Paris? No worries. You can find your closest Défenseur des Droits delegate and talk to them directly. Accessibility help is everywhere!",
    onClick: () => window.open("https://www.defenseurdesdroits.fr/saisir/delegues", "_blank", "noreferrer,noopener"),
    rightSection: <IconExternalLink aria-label="Open regional Ombudsman page" size={24} stroke={1.5} />,
  },
  {
    id: "accessibility-phone",
    label: "Call the Ombudsman 📞",
    description:
      "Prefer a good old phone call? Reach the Défenseur des Droits team directly at +33 9 69 39 00 00. Real humans, real help!",
    onClick: () => window.open("tel:+33969390000", "_blank", "noreferrer,noopener"),
    rightSection: <IconPhone aria-label="Open your phone app" size={24} stroke={1.5} />,
  },
  {
    id: "postal-mail-accessibility",
    label: "Send a Letter 📬",
    description:
      "Feeling old-school? You can send postal mail to: Libre réponse 71120, 75342 Paris CEDEX 07. Yes, snail mail still matters!",
    onClick: () => onSubmit("/accessibility"),
    rightSection: <IconAccessible aria-label="Go to Postal Mail info" size={24} stroke={1.5} />,
  },
];
